import Card from "@/components/shared-ui/Card";
import * as Styled from "./styled";
import Button from "@/components/shared-ui/Button";
import ContactCard from "@/components/shared-ui/ContactCard";
import useCompany from "@/contexts/CompanyContext";
import SalesWelcomeCard from "../WelcomeCards/SalesWelcomeCard";
import TrainingCard from "../TrainingCard";

const DashboardProspecting = () => {
  const { companyName } = useCompany();

  return (
    <>
      <Card
        gridColumn="1 / -1"
        noPadding
        featureBackground={{ full: true, gradient: "light2" }}
      >
        <SalesWelcomeCard companyName={companyName} />
      </Card>

      <Card gridColumn={"1"} featureBackground={{ gradient: "light2" }}>
        <Styled.CardContent>
          <Styled.CardHeading>Process documentation</Styled.CardHeading>
          <p>
            Find detailed information on the operational and technical processes
            involved in launching and running a platform on Seccl's technology.
          </p>
        </Styled.CardContent>
        <Button
          data-testid="processDocsButton"
          variant="secondary"
          internalLink="/docs"
          label="All documents"
          centered
        />
      </Card>

      <Card gridColumn={["1", "2"]} featureBackground={{ gradient: "light2" }}>
        <Styled.CardContent>
          <Styled.CardHeading>Useful documents</Styled.CardHeading>
          <p>Check out our range of handy guides on how we work together.</p>
        </Styled.CardContent>
        <Button
          data-testid="usefulDocumentsButton"
          variant="secondary"
          internalLink="useful-documents"
          label="All documents"
          centered
        />
      </Card>

      <Card gridColumn="1 / span 2">
        <Styled.CardHeading>Due diligence</Styled.CardHeading>
        <p>
          Carry out your due diligence on Seccl with the help of our
          comprehensive FAQ library.
        </p>
        <Button
          variant="tertiary"
          internalLink="due-diligence"
          label="See documents"
        />
      </Card>

      <TrainingCard />

      <ContactCard />
    </>
  );
};

export default DashboardProspecting;
